module.exports = __webpack_public_path__ + "img/icon-billing.635c2bab.svg";